import { Hub } from '@sentry/browser';
import { ReportingObserver } from '@sentry/integrations';
import { debugMessage } from '../debugMessage';

export class S4MPReportingObserver {
  public static id: string = 'S4MPReportingObserver';
  public name: string = S4MPReportingObserver.id;
  private _hub: Hub;
  options: ConstructorParameters<typeof ReportingObserver>[0];

  constructor(
    hub: Hub,
    reportingOptions: ConstructorParameters<typeof ReportingObserver>[0],
  ) {
    this._hub = hub;
    this.options = reportingOptions;
  }

  setupOnce() {
    debugMessage('sentry: setting up S4MPReportingObserver integration');
    new ReportingObserver(this.options).setupOnce(
      () => {},
      () => this._hub,
    );
  }
}
